export * from './header.component';
export * from './menu-left.component';
export * from './footer.component';
export * from './login.component';
export * from './start-menprocess.component';